package com.rosario.juridico.ui.screens

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.expandVertically
import androidx.compose.animation.shrinkVertically
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.navigation.NavController
import com.rosario.juridico.navigation.Routes

private data class SubItemAlquiler(
    val titulo: String,
    val clave: String,
)

private data class CategoriaAlquiler(
    val numero: String,
    val emoji: String,
    val nombre: String,
    val items: List<SubItemAlquiler>,
)

private val categoriasAlquiler = listOf(
    CategoriaAlquiler(
        numero = "1",
        emoji = "Casa",
        nombre = "Vivienda",
        items = listOf(
            SubItemAlquiler("Contrato de locacion familiar", "contrato_locacion_familiar"),
            SubItemAlquiler("Renovacion contrato vivienda", "renovacion_contrato_vivienda"),
            SubItemAlquiler("Prorroga de contrato vivienda", "prorroga_contrato_vivienda"),
        ),
    ),
    CategoriaAlquiler(
        numero = "2",
        emoji = "Local",
        nombre = "Comercial",
        items = listOf(
            SubItemAlquiler("Alquiler local comercial", "alquiler_local_comercial"),
            SubItemAlquiler("Contrato para oficina", "contrato_para_oficina"),
            SubItemAlquiler("Alquiler de galpon o deposito", "alquiler_galpon_deposito"),
            SubItemAlquiler("Alquiler de consultorio", "alquiler_consultorio"),
        ),
    ),
    CategoriaAlquiler(
        numero = "3",
        emoji = "Temp",
        nombre = "Profesional y temporario",
        items = listOf(
            SubItemAlquiler("Alquiler temporario turistico", "alquiler_temporario_turistico"),
            SubItemAlquiler("Alquiler temporario laboral", "alquiler_temporario_laboral"),
            SubItemAlquiler("Alquiler por temporada", "alquiler_por_temporada"),
        ),
    ),
    CategoriaAlquiler(
        numero = "4",
        emoji = "Plus",
        nombre = "Especiales",
        items = listOf(
            SubItemAlquiler("Leasing inmobiliario", "leasing_inmobiliario"),
            SubItemAlquiler("Comodato", "comodato_prestamo_gratuito"),
            SubItemAlquiler("Alquiler con opcion a compra", "alquiler_opcion_a_compra"),
            SubItemAlquiler("Contrato de sublocacion", "contrato_sublocacion"),
        ),
    ),
    CategoriaAlquiler(
        numero = "5",
        emoji = "Partes",
        nombre = "Sujetos del contrato",
        items = listOf(
            SubItemAlquiler("Contrato con garante propietario", "contrato_garante_propietario"),
            SubItemAlquiler("Contrato con seguro de caucion", "contrato_seguro_caucion"),
            SubItemAlquiler("Contrato con fiador solidario", "contrato_fiador_solidario"),
        ),
    ),
    CategoriaAlquiler(
        numero = "6",
        emoji = "Pago",
        nombre = "Modalidad de pago",
        items = listOf(
            SubItemAlquiler("Alquiler con ajuste por IPC", "alquiler_ajuste_ipc"),
            SubItemAlquiler("Alquiler con ajuste semestral", "alquiler_ajuste_semestral"),
            SubItemAlquiler("Alquiler con precio fijo", "alquiler_precio_fijo"),
            SubItemAlquiler("Alquiler en dolares", "alquiler_en_dolares"),
            SubItemAlquiler("Notificacion canon actualizado", "notificacion_canon_actualizado"),
        ),
    ),
    CategoriaAlquiler(
        numero = "7",
        emoji = "Fin",
        nombre = "Finalizacion del contrato",
        items = listOf(
            SubItemAlquiler("Rescision anticipada inquilino", "rescision_anticipada_inquilino"),
            SubItemAlquiler("Rescision por incumplimiento", "rescision_por_incumplimiento"),
            SubItemAlquiler("Finalizacion de contrato", "finalizacion_de_contrato"),
            SubItemAlquiler("Intimacion de desalojo", "intimacion_de_desalojo"),
            SubItemAlquiler("Solicitud de renovacion", "solicitud_renovacion_locatario"),
            SubItemAlquiler("Rescision por falta de renovacion", "rescision_por_falta_renovacion"),
        ),
    ),
    CategoriaAlquiler(
        numero = "8",
        emoji = "Docs",
        nombre = "Documentos vinculados",
        items = listOf(
            SubItemAlquiler("Recibo de alquiler", "recibo_de_alquiler"),
            SubItemAlquiler("Acta de entrega de inmueble", "acta_entrega_inmueble"),
            SubItemAlquiler("Inventario inicial", "inventario_inicial"),
            SubItemAlquiler("Intimacion de pago", "intimacion_de_pago"),
        ),
    ),
    CategoriaAlquiler(
        numero = "9",
        emoji = "Rep",
        nombre = "Reparaciones",
        items = listOf(
            SubItemAlquiler("Intimacion reparaciones urgentes", "reparaciones_urgentes_locatario"),
            SubItemAlquiler("Intimacion reparaciones no urgentes", "reparaciones_no_urgentes_locatario"),
        ),
    ),
)

@Composable
fun PantallaModelosAlquiler(navController: NavController) {
    var categoriaAbierta by remember { mutableStateOf<String?>(null) }

    LazyColumn(
        modifier = Modifier
            .fillMaxSize()
            .padding(horizontal = 16.dp, vertical = 12.dp),
        verticalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        item {
            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                Text(
                    text = "Modelos de contrato de alquiler",
                    style = MaterialTheme.typography.headlineSmall,
                    fontWeight = FontWeight.Bold,
                    color = MaterialTheme.colorScheme.primary,
                )
                Text(
                    text = "Elegi una categoria para abrir el generador con la plantilla correspondiente.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }

        items(categoriasAlquiler) { categoria ->
            CategoriaAlquilerCard(
                categoria = categoria,
                estaAbierta = categoriaAbierta == categoria.nombre,
                onToggle = {
                    categoriaAbierta = if (categoriaAbierta == categoria.nombre) null else categoria.nombre
                },
                onSubItemClick = { subItem ->
                    navController.navigate(Routes.generadorContrato(subItem.clave))
                },
            )
        }

        item { Spacer(modifier = Modifier.height(20.dp)) }
    }
}

@Composable
private fun CategoriaAlquilerCard(
    categoria: CategoriaAlquiler,
    estaAbierta: Boolean,
    onToggle: () -> Unit,
    onSubItemClick: (SubItemAlquiler) -> Unit,
) {
    Card(
        modifier = Modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(
            containerColor = if (estaAbierta) {
                MaterialTheme.colorScheme.primaryContainer
            } else {
                MaterialTheme.colorScheme.surfaceVariant
            },
        ),
        elevation = CardDefaults.cardElevation(defaultElevation = if (estaAbierta) 4.dp else 1.dp),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable(onClick = onToggle)
                .padding(horizontal = 16.dp, vertical = 14.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Text(
                text = categoria.emoji,
                style = MaterialTheme.typography.labelLarge,
                fontWeight = FontWeight.Bold,
                color = MaterialTheme.colorScheme.primary,
                modifier = Modifier.padding(end = 10.dp),
            )
            Text(
                text = "${categoria.numero}. ${categoria.nombre}",
                style = MaterialTheme.typography.titleSmall,
                fontWeight = FontWeight.SemiBold,
                color = if (estaAbierta) {
                    MaterialTheme.colorScheme.onPrimaryContainer
                } else {
                    MaterialTheme.colorScheme.onSurfaceVariant
                },
                modifier = Modifier.weight(1f),
            )
            Icon(
                imageVector = if (estaAbierta) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown,
                contentDescription = null,
                tint = if (estaAbierta) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }

        AnimatedVisibility(
            visible = estaAbierta,
            enter = expandVertically(),
            exit = shrinkVertically(),
        ) {
            Column {
                HorizontalDivider(color = MaterialTheme.colorScheme.outline.copy(alpha = 0.2f))
                categoria.items.forEachIndexed { index, subItem ->
                    SubItemAlquilerRow(subItem = subItem, onClick = { onSubItemClick(subItem) })
                    if (index < categoria.items.lastIndex) {
                        HorizontalDivider(
                            modifier = Modifier.padding(horizontal = 16.dp),
                            color = MaterialTheme.colorScheme.outline.copy(alpha = 0.12f),
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun SubItemAlquilerRow(
    subItem: SubItemAlquiler,
    onClick: () -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = 18.dp, vertical = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            text = ">",
            fontSize = 18.sp,
            color = MaterialTheme.colorScheme.primary,
            modifier = Modifier.padding(end = 12.dp),
        )
        Text(
            text = subItem.titulo,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.weight(1f),
        )
        Surface(
            color = MaterialTheme.colorScheme.secondaryContainer,
            shape = MaterialTheme.shapes.small,
        ) {
            Text(
                text = "Completar",
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.onSecondaryContainer,
                modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp),
            )
        }
    }
}
